import { kv } from '../config/kv/kvConfig';

export const updateKvWith = async (key: string, value: string) => {
  await kv.set(key, value);
};
